import { Box, Image } from '@chakra-ui/react';
import { useWindowBreakpoints } from '../../../../components/window';

export interface BlogContentImageProps {
  src?: string | null;
  url?: string | null;
  altText?: string | null;
  title?: string | null;
  width?: number | null;
  height?: number | null;
}

/**
 * Responsive image for GraphCMS rich-text embeds (`img` / `Asset.image`).
 * Ignores fixed CMS width/height attributes so images scale with the OS window.
 */
export function BlogContentImage({
  src,
  url,
  altText,
  title,
  width: _assetWidth,
  height: _assetHeight,
}: BlogContentImageProps) {
  const { isXs, isSm } = useWindowBreakpoints();
  const imageSrc = src || url || '';

  if (!imageSrc) {
    return null;
  }

  // Keep inline images within the article column; slightly full-bleed on narrow windows.
  const maxW = isXs ? '100%' : isSm ? '100%' : '100%';
  const my = isXs ? 4 : isSm ? 5 : 6;

  return (
    <Box
      as="figure"
      className="blog-content-image"
      w="100%"
      maxW={maxW}
      my={my}
      mx="auto"
      display="block"
    >
      <Image
        src={imageSrc}
        alt={altText || title || ''}
        title={title || undefined}
        loading="lazy"
        w="100%"
        maxW="100%"
        h="auto"
        maxH={isXs ? '320px' : isSm ? '420px' : '560px'}
        objectFit="contain"
        objectPosition="center"
        display="block"
        borderRadius="6px"
        mx="auto"
      />
    </Box>
  );
}

export default BlogContentImage;
